import React, { useState } from "react";
import { ContentHeader } from "@components";
import API from "../api";
import toastr from "toastr";

const ChangePassword: React.FC = () => {
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Submit form
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.current_password || !form.new_password || !form.confirm_password) {
      toastr.error("All fields are required");
      return;
    }

    if (form.new_password !== form.confirm_password) {
      toastr.error("New passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const res = await API.post("/changePassword", form);
      if (res.data.success) {
        toastr.success("Password changed successfully");
        setForm({ current_password: "", new_password: "", confirm_password: "" });
      } else {
        toastr.error(res.data.message || "Failed to change password");
      }
    } catch (err: any) {
      toastr.error(err.response?.data?.message || "Error updating password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ContentHeader title="Change Password " />

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-primary">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Current Password */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Current Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="current_password"
                      value={form.current_password}
                      onChange={handleChange}
                      placeholder="Enter current password"
                      required
                    />
                  </div>

                  {/* New Password */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="new_password"
                      value={form.new_password}
                      onChange={handleChange}
                      placeholder="Enter new password"
                      required
                    />
                  </div>

                  {/* Confirm Password */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Confirm New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="confirm_password"
                      value={form.confirm_password}
                      onChange={handleChange}
                      placeholder="Re-enter new password"
                      required
                    />
                  </div>
                </div>

                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    <i className="fas fa-key"></i>{" "}
                    {loading ? "Updating..." : "Change Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChangePassword;
